import {
  Body1,
  MoiaButton,
  MoiaFormTextField,
} from '@backoffice-frontend/patterns'
import { useValidators } from '@backoffice-frontend/validators'
import { Text } from '@moia-dev/pace-web'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next'

export type ChangePasswordValues = {
  newPasswordRepeat: string
  newPassword: string
  oldPassword: string
}
export const ChangePasswordForm = ({
  onSubmit,
  errorMessage,
  changeSuccess,
}: {
  onSubmit: (values: ChangePasswordValues) => Promise<void>
  errorMessage?: string
  changeSuccess: boolean
}) => {
  const { t } = useTranslation()
  const { required } = useValidators()
  return (
    <Form
      validate={values => {
        if (values.newPasswordRepeat !== values.newPassword) {
          return {
            newPasswordRepeat: t('common_newPasswordMismatch_error'),
            newPassword: t('common_newPasswordMismatch_error'),
          }
        }

        return {}
      }}
      onSubmit={onSubmit}
    >
      {({ invalid, submitting, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <input hidden type="text" name="username" autoComplete="username" />
          <Text
            size="sm"
            css={theme => ({ paddingBottom: `${theme.space.Space6}` })}
          >
            <Text weight="bold">{t('common_passwordPolicy_header')}</Text>
            <Text
              css={theme => ({
                display: 'block',
                whiteSpace: 'pre-line',
                paddingLeft: theme.space.Space1,
                paddingBottom: theme.space.Space3,
              })}
            >
              {t('common_passwordPolicy')}
            </Text>
          </Text>
          <Field
            label={t('authenticatedAppView_oldPassword_label')}
            disabled={submitting}
            type="password"
            name="oldPassword"
            id="oldPassword"
            inputProps={{
              autoComplete: 'current-password',
            }}
            css={{
              input: {
                color: 'var(--color-content-default) !important',
                WebkitTextFillColor: 'var(--color-content-default) !important',
                WebkitBackgroundClip: 'text !important',
                backgroundClip: 'text !important',
              },
            }}
            component={MoiaFormTextField}
            validate={required}
          />

          <Field
            label={t('authenticatedAppView_newPassword_label')}
            disabled={submitting}
            type="password"
            name="newPassword"
            id="newPassword"
            inputProps={{
              autoComplete: 'new-password',
            }}
            component={MoiaFormTextField}
            validate={required}
          />

          <Field
            label={t('authenticatedAppView_newPasswordRepeat_label')}
            disabled={submitting}
            type="password"
            inputProps={{
              autoComplete: 'new-password',
            }}
            name="newPasswordRepeat"
            id="newPasswordRepeat"
            component={MoiaFormTextField}
            validate={required}
          />

          {errorMessage && (
            <Body1 paragraph color="error">
              {errorMessage}
            </Body1>
          )}

          {changeSuccess && (
            <Body1 paragraph color="primary">
              {t('authenticatedAppView_passwordChangedSuccessfully')}
            </Body1>
          )}

          <MoiaButton type="submit" submitting={submitting} disabled={invalid}>
            {t('authenticatedAppView_changePassword_button')}
          </MoiaButton>
        </form>
      )}
    </Form>
  )
}
